import React from 'react';

import Code from '../base';

const codestring = `const fetch = require('node-fetch');
const jose = require('jose');

// permission stuff
const username = '6d11075e-29ad-42b5-9bca-b5f278f9133c';
const password = 'UiHmmDOiUkH6c1b6VntTb4tzSy1jrCUha2N41DH73RY';
const token = {"use":"sig","kty":"EC","kid":"6d11075e-29ad-42b5-9bca-b5f278f9133c","crv":"P-256","x":"7X-4jabUvQpZkIWWnbt7xpZHZY6cg8aoMt2JDQZZFzk","y":"Q2QnijBzEkWIKgeX73R6jsgRy9SyOluq9dkZVILRWt0","d":"vhrEnF43ePIOCWmgAJDsWQVmTV9InDMB1F3Ao9lBExk"};

// IDs
const business_id = '813c88b0fb668a0b7087be0550000fd0';
const account_id = '613b945a-2368-4dd1-9d83-b951bc77156d';
// must be unique!
const transfer_id = '07fb92e4-ebe4-4d1c-8606-a1360bc81844';
const destination_account = 'd8bc0fff-dd74-41f3-a116-04a8c260e0b9';

// value_ts
const n = new Date();
const value_ts = Math.floor(n / 1000);
const transaction_id = n.getFullYear() + '-' + ('0' + (n.getMonth()+1)).slice(-2) + '-' + transfer_id;

// request stuff
const url = \`https://b2b-api.lana-staging.xyz/business/\${business_id}/accounts/\${account_id}/transfers/\${transaction_id}\`;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ' + Buffer.from(\`\${username}:\${password}\`).toString('base64'),
};

const buildSignature = ({id, ts, business, amount, currency, source_uri, dest_uri}, token) => {
    const key = jose.JWK.asKey(token);
    const payload = {
        id: id,
        vTS: ts,
        bID: business,
        a: amount,
        c: currency,
        s: source_uri,
        d: dest_uri,
    }

    return jose.JWT.sign(payload, key, {algorithm: 'ES256'});
};

const data = {
    id: transaction_id,
    desc: 'description test',
    name: 'foo bar',
    destination_uri: destination_account_uri,
    value_ts: value_ts,
    amount: 100,
    currency: 'MXN',
    signature: buildSignature({
        id: transaction_id,
        ts: value_ts,
        business: business_id,
        amount: 100,
        currency: 'MXN',
        source_uri: account.gateway_uri,
        dest_uri: destination_account_uri,
    }, token),
};

fetch(url, { headers: headers, method: 'PUT', body: JSON.stringify(data) }).then(response => {
    if (response.status !== 201) {
        throw Error(response.status);
    }
}).catch(error => {
    console.log('Error creating transaction', error)
});`;

const NodeCreateTransaction = () => <Code language="javascript" codestring={codestring} />;

export default NodeCreateTransaction;
